// Pulls the checkbox in line with the field above it, since the checkbox brings its own padding around the box.
export const checkboxBelowFieldMargin = { marginLeft: -1, marginBottom: -1, marginRight: 0, marginTop: 0 };
